import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import { Button, Grid } from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import ListEventTypes from '../molecules/messages/ListEventTypes';
import EditEventType from '../molecules/messages/EditEventType';
import DeleteEventTypeAlert from '../molecules/alerts/DeleteEventTypeAlert';
import { handleSnackBar, setTabOnFocus } from '../../store/global/actions';
import { useForm } from "react-hook-form";
import CreateMessage from '../molecules/messages/CreateMessage'
import ImportMessage from '../molecules/messages/ImportMessage'
import { getTabOnFocus } from '../../store/global/selectors';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';


export default function EventTypes({ element, bottomDrawer, openedTab }) {
    const dispatch = useDispatch();
    const [openTab, setOpenTab] = useState(0);
    const [action, setAction] = useState({});
    const [breadCrumbItem, setBreadCrumbItem] = useState([])
    const messages = { validate: 'The event name is already used.' };
    const [message, setMessage] = useState(null);

    const tabOnFocus = useSelector(getTabOnFocus);
    const bottomDrawerContext = useBottomDrawer();
    const {setActiveTab, setTabConfig, activeTab} = bottomDrawer ? bottomDrawerContext : {}

    const detailsBC = [
        { label: 'Event Types', url: null },
    ];

    const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();


    useEffect(() => {
        if (action.item?.name) {
            setBreadCrumbItem([{ label: action.item?.name, url: null }]);
        } else {
            setBreadCrumbItem([])
        }
    }, [action])

    useEffect(() => {
        if(message != null){
            setBreadCrumbItem([{ label: message.name, url: null }]);
        }
    }, [message])

    useEffect(() => {
        if(bottomDrawer){
            setActiveTab(openedTab || tabOnFocus)
        }else{
            setOpenTab(tabOnFocus);
        }
        setAction({});
        setBreadCrumbItem([])
    }, [tabOnFocus, openedTab]);

    useEffect(() => {
        if(element?.action){
            setAction(element.action);
        }
    },[element])

    const onCompletion = (type, action) => {

        console.log("OnDeleteEventtype-----", {type,action})
        if (action != undefined) {

            switch (action) {
                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    break;
                default:
                    break;
            }
            setAction({})
            

        }
    }

    const onClose = () => {
        setAction({})
    }

    const onActionCompletion = (newMessage) => {
        setAction({ action: 'edit_event_type', id: newMessage._id, item: newMessage });
        setMessage(newMessage);
    }

    const onActionClose = () => {
        setAction({})
    }

    useEffect(() => {
        if(bottomDrawer){
            setTabConfig([
                {
                    label: "Event Types",
                },
                {
                    label: "Import Event Types",
                    isDisabled: Object.keys(action).length > 0
                }
            ])
        }
    },[action])    

    return (
        <>
            {
                !bottomDrawer &&
                <AppBar position="static">
                    <Tabs value={openTab} aria-label="simple tabs example" onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }}>
                        <Tab label="Event Types" />
                        <Tab label="Import Event Types" />
                    </Tabs>
                </AppBar>
            }

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={0} >
                <Grid container direction="row" spacing={3} style={{minHeight: '7px'}}>

                   {
                    !bottomDrawer &&
                    <Grid item xs={8}>
                        <BreadCrumb items={[...detailsBC, ...breadCrumbItem]} />
                    </Grid>
                   }



                    {Object.keys(action).length > 0 && <Grid item xs={bottomDrawer ? 12 : 4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="List event types">
                            <Button onClick={e => setAction({})} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }} id="go_back_btn">
                                Go back to list
                            </Button>
                        </Tooltip>
                    </Grid>}

                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                

                {(Object.keys(action).length === 0 || action.action === 'delete_event_type') && <CreateMessage element={element} onClose={onActionClose} onActionCompletion={onActionCompletion} />}

                {(Object.keys(action).length === 0 || action.action === 'delete_event_type') && <ListEventTypes element={element} setAction={setAction} />}

                {action.action === 'edit_event_type' && <EditEventType parent={action.id} onClose={onClose} item={action.item} setMessage={setMessage} />}

                {action.action === 'delete_event_type' && <DeleteEventTypeAlert eventTypeId={action.id} onClose={onClose} onCompletion={onCompletion} />}

            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={1} >
                {
                    !bottomDrawer &&
                    <>
                        <Grid container direction="row" spacing={3}>

                            <Grid item xs={8}>
                                <BreadCrumb items={[...detailsBC, { label: 'Import Event Types', url: null }]} />
                            </Grid>

                        </Grid>
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }



                {Object.keys(action).length === 0 && <ImportMessage onClose={onActionClose} onActionCompletion={onActionCompletion} />}


            </TabPanel>
        </>
    )
}